export const IMAGES = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/9f791f07-d498-4b3d-ac30-3a8629e39c79/images/afe5b1b9fbff8529f5ce6dda6709a7b54e7dfe8dbbefa71e3cbcbeab9c9d5aa9.png",
  formflow:
    "https://static.prod-images.emergentagent.com/jobs/9f791f07-d498-4b3d-ac30-3a8629e39c79/images/83bf25ca3be8cd5444dcd1424ccb41ffc0067d266a4cf614f78aa31614298585.png",
  memberspace:
    "https://static.prod-images.emergentagent.com/jobs/9f791f07-d498-4b3d-ac30-3a8629e39c79/images/98266b0274c1ea86b4e79eacc696dc84cd248efa481d31e40187d657a7a564ff.jpeg",
  founder: "/abhilash-founder.jpg",
};

export const FOUNDER = {
  name: "Abhilash Gampa",
  title: "Founder & Chief Architect",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Partner", href: "#partner" },
  { label: "Founder", href: "#founder" },
  { label: "Contact", href: "#contact" },
];

export const COMPANY = {
  name: "Rishmathi Tech Ventures Private Limited",
  shortName: "Rishmathi",
  cin: "U58200TS2026PTC216367",
  location: "Rangareddy, Telangana, India",
  email: "contact@rishmathi.com",
  phone: "8019091218",
};
